import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'gatsby';
import PageLayout from '../components/PageLayout';
import styles from './session.module.scss';
import fbIcon from '../assets/images/fb-icon.png';
import twitterIcon from '../assets/images/twitter-icon.png';
import { Reading } from '../components';
import GoChevronLeft from 'react-icons/lib/go/chevron-left';
import defaultShareImage from '../assets/images/default-share-image.jpg';

const Readings = ({ readings }) => {
  if(!readings || readings.length === 0) return null;
  return (
    <div className={styles.readings}>
      <h3>RECOMMENDED READINGS</h3>
      {readings.map(reading => (
        <Reading reading={reading} key={reading.title} />
      ))}
    </div>
  );
}

const SessionTemplate = (props) => {
  const { frontmatter: { title, day, time, stream, image, shareImage, readings }, html} = props.data.markdownRemark;
  const shareURL = "https://www.marxismconference.org" + props.location.pathname;
  return (
    <PageLayout location={props.location}>
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        {html ? <meta property="og:description" content={html.replace(/<\/?[^>]+(>|$)/g, "")} /> : ''}
        {shareImage ? <meta property="og:image" content={shareImage} /> : ''}
        {shareImage ? <meta property='twitter:image:src' content={shareImage} /> : ''}
        <meta property='twitter:title' content={title} />
      </Helmet>
      <div className={styles.content}>
        {<img src={image || defaultShareImage} className={styles.image} alt="" /> }
        <div className={styles.dayTime}>{day} {time}</div>
        <h1 className={styles.title}>{title}</h1>
        <div className={styles.stream}>{stream}</div>
        <div className={styles.shareSpeaker}>
          SHARE THIS SESSION:
          <a href={"http://www.facebook.com/sharer/sharer.php?u=" + shareURL} target="_blank" rel="noopener noreferrer">
            <div className={styles.icon}>
              <img src={fbIcon} className={styles.fbIcon} alt="Facebook" />
            </div>
          </a>
          <a href={"https://twitter.com/share?text=" + title + " at Marxism 2020&url=" + shareURL} target="_blank" rel="noopener noreferrer">
            <div className={styles.icon}>
            <img src={twitterIcon} className={styles.twitterIcon} alt="Twitter" />
            </div>
          </a>
        </div>
        <div className={styles.description} dangerouslySetInnerHTML={{__html: html}} />
        <Readings readings={readings} />
        <Link className={styles.backButton} to='/program/'><GoChevronLeft /> View Full Program</Link>
      </div>
    </PageLayout>
  );
}

export default SessionTemplate;

export const pageQuery = graphql`
  query GetSession($path: String!) {
    markdownRemark(fields: { path: { eq: $path } }) {
      html,
      frontmatter {
        title,
        day,
        time,
        stream,
        image,
        shareImage,
      }
    }
  }
`;
